import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Cookie from "universal-cookie";
import { decrypt } from "./useCryptoJS";
import UserTable from "./tables/UserTable";
import CreateUserForm from "./CreateUserForm";

import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Container,
  Divider,
} from "@mui/material";

const glassCard = {
  background: "rgba(15, 23, 42, 0.72)",
  borderRadius: "16px",
  padding: "1.75rem",
  border: "1px solid rgba(148,163,184,0.22)",
  boxShadow: "0 0 0 1px rgba(255,255,255,0.03), 0 18px 45px rgba(15,23,42,0.9)",
  color: "#e5e7eb",
};

const headerText = {
  fontSize: "2.3rem",
  fontWeight: 700,
  color: "#e5e7eb",
  textAlign: "center",
  marginBottom: "2rem",
  textShadow: "0 8px 32px rgba(0,0,0,0.4)",
};

const sectionTitle = {
  fontSize: "1.65rem",
  fontWeight: 600,
  color: "#bfdbfe",
  marginBottom: "1.2rem",
  textAlign: "left",
};

const UserManagement_Users = () => {
  const cookies = new Cookie();
  const [uruser, setUruser] = useState("0000");
  const [userToEdit, setUserToEdit] = useState(null);
  const [selectedUser, setSelectedUser] = useState([]);

  useEffect(() => {
    try {
      setUruser(decrypt(cookies.get("uruser")));
    } catch (error) {}
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "radial-gradient(circle at top, #1e293b 0%, #020617 70%)",
      }}
    >
      <Navbar />

      <Container maxWidth="xl" sx={{ pt: 6, pb: 4 }}>
        <Typography sx={headerText}>User Management</Typography>

        <Grid container spacing={4} justifyContent="center">
          {(uruser.charAt(0) === "1" ||
            uruser.charAt(2) === "1" ||
            uruser.charAt(3) === "1") && (
            <Grid item xs={12} md={7}>
              <Paper elevation={0} sx={glassCard}>
                <Typography sx={sectionTitle}>Current Users</Typography>
                <Divider
                  sx={{ borderColor: "rgba(255,255,255,0.08)", mb: 3 }}
                />

                <UserTable
                  setUserToEdit={setUserToEdit}
                  edit={uruser.charAt(2) === "1"}
                  deletee={uruser.charAt(3) === "1"}
                  setSelectedUser={setSelectedUser}
                />
              </Paper>
            </Grid>
          )}

          {uruser.charAt(1) === "1" && (
            <Grid item xs={12} md={5}>
              <Paper elevation={0} sx={glassCard}>
                <Typography sx={sectionTitle}>
                  {userToEdit ? "Edit User" : "Create User"}
                </Typography>
                <Divider
                  sx={{ borderColor: "rgba(255,255,255,0.08)", mb: 3 }}
                />

                <Box sx={{ mt: 2 }}>
                  <CreateUserForm
                    userToEdit={userToEdit}
                    setUserToEdit={setUserToEdit}
                  />
                </Box>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
};

export default UserManagement_Users;
